import { render } from "./Servicos.vue?vue&type=template&id=00ce8992&scoped=true"
const script = {}

import "./Servicos.vue?vue&type=style&index=0&id=00ce8992&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\campinasredesdeprotecao\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ce8992"]])

export default __exports__